import Card from '../templates/ui/Card'
import Button from '../templates/ui/Button'
import { useCampaignStore } from '../app/store/campaignStore'
import './RedeemReward.css'

export default function RedeemReward() {
  const { state } = useCampaignStore()
  const topPartyLeaders = [
    { id: 1, name: 'user_01', successParty: 20 },
    { id: 2, name: 'user_02', successParty: 14 },
    { id: 3, name: 'user_03', successParty: 12 }
  ]

  return (
    <section className="mobile-page redeem-page mx-auto w-full max-w-md">
      <Card className="mobile-panel redeem-card">
        <div className="landing-header px-4 py-4 md:px-6">
          <p className="landing-badge">Big C Receipt Mutelu</p>
          <h1 className="landing-title mt-1 md:text-3xl">
            {state.campaign.redeem?.campaignName || state.campaign.campaignName}
          </h1>
          <p className="landing-subtitle mt-1">
            {state.campaign.redeem?.tagline}
          </p>
        </div>

        <div className="redeem-body">
          {/* <div className="redeem-convert">
            <div className="redeem-icon">🎟️</div>
            <div>
              <p className="redeem-title">Conversion</p>
              <p className="redeem-sub">แลกตั๋วทั้งหมดเป็น Big Pointเข้าบัตรทันที</p>
            </div>
          </div> */}

          <div className="redeem-prize">
            <p className="redeem-prize-title">Top 3 ผู้เล่นที่คะแนนสูงสุด</p>
            <div className="redeem-rank-list">
              {topPartyLeaders.map((leader) => (
                <div key={leader.id} className="redeem-rank-item">
                  <p className="redeem-rank-order">#{leader.id}</p>
                  <div className="redeem-rank-content">
                    <p className="redeem-rank-name">{leader.name}</p>
                  </div>
                  <p className="redeem-rank-score">สำเร็จ {leader.successParty} ครั้ง</p>
                </div>
              ))}
            </div>
          </div>

          <Button className="btn-uniform redeem-btn">คูปองทั้งหมด</Button>
        </div>
      </Card>
    </section>
  )
}
